export default "__VITE_ASSET__cfe4e8df__"